import { SliderThumb } from "@mui/material";
import React, { ReactNode } from "react";

const CustomThumb: React.FC<CustomThumbProps> = ({
  value,
  children,
  ...other
}) => {
  return (
    <SliderThumb {...other}>
      {children}

      <div className="custom-thumb-outer-container">
        <div className="custom-thumb-inner-container">
          <span className="custom-thumb-value">{value}°C</span>
        </div>
      </div>
    </SliderThumb>
  );
};

export default CustomThumb;

export interface CustomThumbProps {
  children?: ReactNode;
  value: number;
}
